<template>
  <div class="supplier-management">
    <h3>请输入查询条件</h3>
    <div style="display: flex;justify-content: space-between;align-items: flex-start;">
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="机器内部编码：">
            <el-input
              placeholder="请输入搜索内容"
              v-model="queryParams.instrumentNumber"
              clearable
              style="border-top-left-radius: 0;border-bottom-left-radius: 0;width: 300px;"
            >
              <i
                slot="suffix"
                class="el-icon-search"
                @click="search"
                style="font-size: 18px;line-height: 40px;margin-right: 10px;color: black;cursor: pointer;"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>接入服务器:{{serverName}}</div>
      <div>描述:{{serverDetail}}</div>
      <div style="margin-bottom: 12px;">
        <el-button type="primary" icon="el-icon-plus" @click="addRemote">新增远程</el-button>
         <el-button type="danger" icon="el-icon-delete" @click="deleteList">批量删除</el-button>
      </div>
    </div>
      <el-table 
      v-loading="loading" 
      :data="queryList"
       ref="multipleTable"
      @selection-change="handleSelectionChange">
      >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="机器内部编码" prop="instrumentNumber" align="center" />
      <el-table-column label="远程域名" prop="remoteDomainName" align="center" />
      <el-table-column label="内部IP" prop="machineAssignIp" align="center" />
      <el-table-column label="远程接入用户名" prop="remoteAccessUsername" align="center" />
      <el-table-column label="远程接入密码" prop="remoteAccessPassword" align="center" />
      <el-table-column label="完整地址" prop="completeAddress" align="center" />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="450px"
      >
        <template  slot-scope="scope">
          <el-link :underline="false" style="margin-right: 10px;" @click="edit(scope.row)"
            ><img src="../../assets/imgs/edit.svg" style="width: 12px;margin-right: 5px;"><span>编辑</span></el-link
          >
          <el-link :underline="false" @click="del(scope.row)"
            ><img src="../../assets/imgs/del.svg" style="width: 12px;margin-right: 5px;"><span>删除</span></el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="block" align="right" style="margin-top: 30px;">
      <el-pagination
        layout="prev,jumper,slot, next"
        :total="total"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange"
      >
        <span style="display: inline;">/ </span>
        <span style="display: inline;">{{ pages }}</span>
      </el-pagination>
    </div>
      <el-dialog
      :visible.sync="isShowDialog"
      width="660px"
      append-to-body
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">{{`${drawerTip}远程`}}</span>
        </div>
      </div>
      <el-form
        :model="queryRemoteForm"
        status-icon
        :rules="rules"
        ref="queryRemoteForm"
        label-width="100px"
        style="display: flex;flex-direction: column;justify-content: space-between;"
      >
        <el-form-item label="机器内部编码:" prop="instrumentNumber">
          <el-input
            v-model="queryRemoteForm.instrumentNumber"
            autocomplete="off"
            placeholder="请输入编码"
          ></el-input>
        </el-form-item>
       <el-form-item label="远程域名:" prop="remoteDomainName">
          <el-input
            v-model="queryRemoteForm.remoteDomainName"
            autocomplete="off"
            placeholder="请输入域名"
          ></el-input>
        </el-form-item>
        <el-form-item label="内部IP:" prop="machineAssignIp">
          <el-input
            v-model="queryRemoteForm.machineAssignIp"
            autocomplete="off"
            placeholder="请输入IP"
          ></el-input>
        </el-form-item>
        <el-form-item label="远程接入用户名:" prop="remoteAccessUsername">
          <el-input
            v-model="queryRemoteForm.remoteAccessUsername"
            autocomplete="off"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
         <el-form-item label="远程接入密码:" prop="remoteAccessPassword">
          <el-input
            v-model="queryRemoteForm.remoteAccessPassword"
            autocomplete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="网络标识:" prop="networkIcon">
          <el-input
            v-model="queryRemoteForm.networkIcon"
            autocomplete="off"
            placeholder="请输入标识"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="配置文件:" prop="configurationFile">
          <el-input
            type="textarea"
            :rows="5"
            v-model="queryRemoteForm.configurationFile"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="完整地址:" prop="completeAddress">
          <el-input
            v-model="queryRemoteForm.completeAddress"
            autocomplete="off"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item class="submit" style="margin-top: 20px;margin-left: 200px;">
          <el-button type="primary" @click="submitForm('queryRemoteForm')" style="width: 120px;"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serverName:'',
      serverDetail:'',
      idList:[],
      loading:true,
      editStyle: false,
      drawerTip:'添加',
      pages: 1,
      check: [],
      drawer: false,
      isShowDialog: false,
      remoteList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        remoteAccessServerId: '',
        instrumentNumber:''
      },
      queryRemoteForm: {
            instrumentNumber:'',
            remoteDomainName:'',
            machineAssignIp:'',
            remoteAccessUsername:'',
            // networkIcon:'',
            remoteAccessPassword:'',
            // configurationFile:'',
            completeAddress:'',
      },
      rules: {
        instrumentNumber: [{ required: true, message: '请输入编码(最大长度255)', trigger: 'blur', min: 1, max: 255 }],
        remoteDomainName:[{ required: true, message: '请输入域名(最大长度36)', trigger: 'blur',min: 1, max: 36 }],
        machineAssignIp:[{ required: true, message: '请输入IP(最大长度255)', trigger: 'blur',min: 1, max: 255 }],
        remoteAccessUsername:[{ required: true, message: '请输入用户名(最大长度255)', trigger: 'blur',min: 1, max: 255 }],
        // networkIcon:[{ required: true, message: '请输入标识(最大长度255)', trigger: 'blur',min: 1, max: 255 }],
        remoteAccessPassword:[{ required: true, message: '请输入密码(最大长度255)', trigger: 'blur',min: 1, max: 255 }],
        // configurationFile:[{ required: true, message: '请输入配置文件(最大长度50000)', trigger: 'blur' ,min: 1, max: 50000 }],
        completeAddress:[{ required: true, message: '请输入地址(最大长度255)', trigger: 'blur',min: 1, max: 255 }],
      },
      delList: [],
      delOne: [],
      queryList: [],
    }
  },
  created() {
    this.getList()
  },

  methods: {
    handleSelectionChange(val){
     if(val.length>0){
  for(let i=0;i<val.length;i++){
        this.idList.push(val[i].id)
      }
     }else{
      this.idList=[]
     }
    
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    },
    addRemote() {
      this.editStyle = false
      this.drawerTip ='添加'
      this.queryRemoteForm = {
            instrumentNumber:'',
            remoteDomainName:'',
            machineAssignIp:'',
            remoteAccessUsername:'',
            // networkIcon:'',
            remoteAccessPassword:'',
            // configurationFile:'',
            completeAddress:'',
      }
      this.isShowDialog = true
    },
    deleteList(){
      if(this.idList.length==0){
        this.$message({
            message: '请先选择要删除的远程连接',
            type: 'error',
          })
      }else{
       this.$confirm('确定删除选中的远程连接吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteConnectionInfo', this.idList, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                })
                this.getList()
              } else {
                this.$message({
                  message: '删除失败',
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
       
      }

    },
    edit(row) {
      this.editStyle = true
      this.drawerTip ='编辑'
      this.isShowDialog = true
      this.queryRemoteForm = Object.assign({}, row)
    },
    // closeDialog() {
    //   this.$refs.queryRemoteForm.clearValidate()
    // },
    handleClose:function(){
      this.isShowDialog = false
      this.$refs.queryRemoteForm.clearValidate()
    },
    submitForm(formName) {
      this.queryRemoteForm.remoteAccessServerId=this.$store.state.list.id
      if (this.editStyle) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.post('/datacenter/updateConnectionInfo', this.queryRemoteForm, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '编辑成功',
                  type: 'success',
                })
                this.isShowDialog = false
                this.getList()
              } else {
                this.$message.error(`编辑失败，${res.data.msg}`)
                this.isShowDialog = false
              }
            })
          } else {
            return false
          }
        })   
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.post('/datacenter/insertConnectionInfo', this.queryRemoteForm, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success',
                })
                this.isShowDialog = false
                this.getList()
              } else {
                this.$message.error(`添加失败，${res.data.msg}`)
                this.isShowDialog = false
              }
            })
          } else {
            return false
          }
        })
      }
      
    },
    del(row){
        let data=[row.id]
        this.$confirm('确定删除该远程连接吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteConnectionInfo',data, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                })
                this.getList()
              } else {
                this.$message({
                  message: '删除失败',
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
       
    },
    search() {
      this.getList()
    },
    getList () {
      this.serverName=this.$store.state.serverName
      this.serverDetail=this.$store.state.serverDetail
      this.queryParams.remoteAccessServerId=this.$store.state.list.id
      this.queryParams.instrumentNumber=this.queryParams.instrumentNumber
      this.$api.post('/datacenter/selectConnPage',this.queryParams, (res) => {
        if(res.data.code==200) {
          this.queryList = res.data.data.list   
          this.total = res.data.data.total
          if (res.data.data.pages === 0) {
            this.pages = 1
          } else {
            this.pages = res.data.data.pages
          }
          this.loading=false
          for(let i = 0; i < this.queryParams.pageSize; i++) {
            this.checked.push(false)
          } 
        }
      })
    },
  },
}
</script>
<style scoped>
::v-deep .el-pagination__jump {
  margin-left: 0 !important;
}
/* ::v-deep .el-input {
  width: 300px;
} */
::v-deep .el-input {
  width: 95% !important;
}
::v-deep .el-pagination__editor.el-input{
  width: 50% !important;
}
::v-deep .el-textarea {
  width: 95% !important;
}
::v-deep .el-form-item__label{
    width: 125px !important;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
  margin-bottom: 20px;
}
.bg-purple {
  border: 1px solid #dcdfe6;
}
.grid-content {
  border-radius: 4px;
  height: 225px;
}
.el-dialog-header-box {
  display: flex;
  flex-direction: row;
}
.dialog-title-block {
  background-color: #3399ff;
  width: 4px;
  height: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.dialog-title-text {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-weight: 700;
}
::v-deep .submit .el-form-item__content {
  margin: 0 !important;
  width: 200px;
}
::v-deep .el-popover {
  min-width: 80px!important;
}
</style>
